import gql from "graphql-tag";

export const UPDATE_COMPANY_CREATION = gql`
  mutation UpdateCompanyCreation($id: ID!, $canceledAt: DateTime) {
    updateCompanyCreation(id: $id, canceledAt: $canceledAt) {
      feedback
    }
  }
`;
